import React from 'react';
import { MdOutlineContactPhone } from "react-icons/md"; 
import { useDispatch, useSelector } from 'react-redux';
import { contactAttributeSliceAction } from '../../store/contactAttributeSlice';
import emptybox from "./../../assets/images/empty-box.png";

const CallContacts = () => {
    const dispatch = useDispatch()
    const contactAttributes = useSelector((state:any)=>{return state.contactAttributeSlice.contactAttributes})
    const selectedContact = useSelector((state:any)=>{return state.contactAttributeSlice.selectedContact})
    const onContactSelect = (contactId:any) => {
        dispatch(contactAttributeSliceAction.setSelectedContact(contactId))
    }
    return (
        <React.Fragment>
            <div className="card wrapup-box collapse show mt-3" id="ChatUser">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className='m-0'>Contacts handled</h6>
                </div>
                <div className="card-body height-400">
                    <ul className='list-unstyled m-0'>
                        {contactAttributes && contactAttributes.map((contactData:any, index:number) => {
                            return (
                                <li className={`${(selectedContact === contactData.contactId) ? "active_contacts" : "inactive_contacts"}`} key={index} onClick={() => onContactSelect(contactData.contactId)}>
                                    <button className='chat-user-box'>
                                        <div className='call-user-icon'>
                                            <MdOutlineContactPhone />
                                        </div>
                                        <div className='chat-user-name'>
                                            <div className='que-name'>{contactData.phone}</div>                                    
                                        </div>
                                    </button>
                                </li>
                            )
                        })}
                    </ul>
                    {contactAttributes.length <= 0 &&
                        <div className='empty-data'>
                            <img className='empty-icon' src={emptybox} alt="empty box icon" />
                            <h4>No data available</h4>
                        </div>
                    }
                </div>
            </div>
        </React.Fragment>
    )
}
export default CallContacts;